import { render, staticRenderFns } from "./CmgCelebrateRewardsModal.vue?vue&type=template&id=707cacd2&scoped=true&lang=pug"
import script from "./cmg-celebrate-rewards-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-celebrate-rewards-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCelebrateRewardsModal.vue?vue&type=style&index=0&id=707cacd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707cacd2",
  null
  
)

export default component.exports